import RemiseFinAnneeFormController from './remise.fin.annee.form.controller';

export default {
    template: require('./remise.fin.annee.form.html'),
    controller: RemiseFinAnneeFormController
};
